(() => {
  const storageKey = 'liberty-custom-order-selection';
  const acceptedMime = {
    ai: ['application/postscript', 'application/illustrator', 'application/vnd.adobe.illustrator', 'application/pdf', 'application/octet-stream'],
    svg: ['image/svg+xml', 'text/xml', 'application/xml', 'text/plain', 'application/octet-stream'],
    pdf: ['application/pdf', 'application/octet-stream'],
  };
  const initialize = (root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('form');
    let data;
    try { data = JSON.parse(root.querySelector('[data-lc-custom-data]').textContent); }
    catch { data = { rows: [] }; }
    let labels = {};
    try { labels = JSON.parse(root.querySelector('[data-lc-order-labels]')?.textContent || '{}'); } catch {}
    const rows = Array.isArray(data.rows) ? data.rows.filter(row => Number.isInteger(Number(row.quantity)) && Number(row.quantity) > 0 && Number(row.quantity) <= 5000) : [];
    const unitRows = Array.isArray(data.unitRows) ? data.unitRows : [];
    const quantityGrid = root.querySelector('.lc-custom__quantity-grid');
    if (quantityGrid && (rows.length || unitRows.length)) {
      quantityGrid.replaceChildren();
      [...new Set([...rows, ...unitRows].map(row => Number(row.quantity)))].sort((a, b) => a - b).forEach(count => {
        const label = document.createElement('label');
        label.className = 'lc-custom__quantity';
        label.dataset.lcQuantityLabel = String(count);
        const input = document.createElement('input');
        input.type = 'radio';
        input.name = 'lc_quantity';
        input.value = String(count);
        input.id = `lc-quantity-${count}-${root.dataset.sectionId}`;
        label.htmlFor = input.id;
        const value = document.createElement('span');
        value.textContent = count.toLocaleString();
        const status = document.createElement('span');
        status.className = 'lc-custom__quantity-status';
        status.dataset.lcQuantityStatus = '';
        label.append(input, value, status);
        quantityGrid.append(label);
      });
    }
    const materialInputs = [...root.querySelectorAll('[name="lc_material"]')];
    const quantityInputs = [...root.querySelectorAll('[name="lc_quantity"]')];
    const exactQuantity = root.querySelector('[data-lc-exact-quantity]');
    const quantityError = root.querySelector('[data-lc-quantity-error]');
    const quantityHint = root.querySelector('[data-lc-quantity-hint]');
    const tierNote = root.querySelector('[data-lc-tier-note]');
    const widthInput = root.querySelector('[data-lc-width]');
    const heightInput = root.querySelector('[data-lc-height]');
    const sizeError = root.querySelector('[data-lc-size-error]');
    const chartBody = root.querySelector('[data-lc-chart-body]');
    const sizeMaxima = [2.5, 3, 3.5, 4, 5];
    const dimensions = () => {
      const width = Number(widthInput.value), height = Number(heightInput.value);
      const valid = widthInput.value.trim() !== '' && heightInput.value.trim() !== '' && Number.isFinite(width) && Number.isFinite(height) && width >= 0.5 && height >= 0.5 && width <= 5 && height <= 5 && widthInput.validity.valid && heightInput.validity.valid;
      return { width, height, valid, sizeMax: valid ? sizeMaxima.find(max => Math.round((width + height) * 100) <= max * 200) : null };
    };
    const logoInputs = [...root.querySelectorAll('[name="lc_logo_help"]')];
    let logoData = { variants: [], copy: {} };
    try { logoData = JSON.parse(root.querySelector('[data-lc-logo-help-data]')?.textContent || '{}'); } catch {}
    const logoCopy = logoData.copy || {};
    const logoTier = () => logoInputs.find(input => input.checked)?.value || 'none';
    const logoVariant = () => (logoData.variants || []).find(variant => variant.sku === (logoTier() === 'basic' ? 'VECTOR-SIMPLE' : 'VECTOR-COMPLEX'));
    const logoPaid = () => logoTier() !== 'none';
    const logoReady = () => !logoPaid() || (logoVariant()?.available && /^\d+$/.test(String(logoVariant()?.id)) && Number(logoVariant()?.price) > 0);
    const logoLabel = () => logoCopy[logoTier() === 'none' ? 'no_help' : logoTier()] || logoTier();
    const artworkDescription = root.querySelector('[data-lc-artwork-description]');
    const uploadNote = root.querySelector('[data-lc-upload-note]');
    const vectorDescription = artworkDescription?.textContent;
    const vectorNote = uploadNote?.textContent;
    const validFileType = (file) => {
      const extension = file.name.split('.').pop().toLowerCase();
      const mime = file.type.split(';')[0].toLowerCase();
      const formats = logoPaid() ? { ...acceptedMime, jpg: ['image/jpeg'], jpeg: ['image/jpeg'], png: ['image/png'] } : acceptedMime;
      return Object.hasOwn(formats, extension) && (!mime || formats[extension].includes(mime));
    };
    const fileInput = root.querySelector('[data-lc-artwork]');
    const fileSelected = root.querySelector('[data-lc-file-selected]');
    const artworkError = root.querySelector('[data-lc-artwork-error]');
    const orderError = root.querySelector('[data-lc-order-error]');
    const summaryTitle = root.querySelector('[data-lc-summary-title]');
    const total = root.querySelector('[data-lc-total]');
    const unitPrice = root.querySelector('[data-lc-unit-price]');
    const summaryNote = root.querySelector('[data-lc-summary-note]');
    const configurationNote = root.querySelector('[data-lc-configuration-note]');
    const submitButtons = [...root.querySelectorAll('[data-lc-submit]')];
    const nextAction = root.querySelector('[data-lc-next-action]');
    const mobileTotal = root.querySelector('[data-lc-mobile-total]');
    const readiness = root.querySelector('[data-lc-readiness]');
    const mobileBar = root.querySelector('[data-lc-mobile-bar]');
    if (mobileBar && 'IntersectionObserver' in window) {
      const visibilityObserver = new IntersectionObserver(entries => {
        mobileBar.dataset.visible = String(entries[0].isIntersecting);
      });
      visibilityObserver.observe(form);
    }
    const dialog = root.querySelector('[data-lc-help-dialog]');
    const notifyJourney = event => root.dispatchEvent(new CustomEvent('lc:journey', { bubbles: true, detail: { event, journey: 'custom' } }));
    const currency = data.currency || document.documentElement.dataset.currency || 'USD';
    let selectedFile = null;
    let activeRow = null;
    let submitting = false;
    let helpTrigger = null;
    let stored = null;
    try { stored = JSON.parse(sessionStorage.getItem(storageKey)); } catch {}
    const query = new URLSearchParams(window.location.search);
    const savedArtwork = window.LibertySavedDesigns?.create(root, query.get('design'));
    const requestedMaterial = query.get('material');
    const requestedHelp = query.get('logo_help');
    const initialMaterial = ['pvc','leatherette'].includes(requestedMaterial) ? requestedMaterial : stored?.material || data.initialMaterial || 'pvc';
    if (stored?.width != null) widthInput.value = stored.width;
    if (stored?.height != null) heightInput.value = stored.height;
    const initialQuantity = String(stored?.quantity || data.initialQuantity || 50);
    const initialHelp = ['none', 'basic', 'complex'].includes(requestedHelp) ? requestedHelp : stored?.logoHelp;
    logoInputs.find(input => input.value === initialHelp && !input.disabled)?.click();
    materialInputs.find(input => input.value === initialMaterial)?.click();
    if (exactQuantity) exactQuantity.value = initialQuantity;
    quantityInputs.find(input => input.value === initialQuantity)?.click();
    const showError = (element, message) => {
      element.textContent = message;
      element.hidden = !message;
    };
    const material = () => materialInputs.find(input => input.checked)?.value;
    const patchCount = () => exactQuantity ? Number(exactQuantity.value) : Number(quantityInputs.find(input => input.checked)?.value || 0);
    const minimumQuantity = () => material() === 'leatherette' ? 12 : 50;
    const validQuantity = () => (!exactQuantity || exactQuantity.value.trim() !== '') && Number.isInteger(patchCount()) && patchCount() >= minimumQuantity() && patchCount() <= 5000;
    const saveSelection = () => {
      try { sessionStorage.setItem(storageKey, JSON.stringify({ material: material(), quantity: patchCount(), width: widthInput.value, height: heightInput.value, logoHelp: logoTier() })); } catch {}
    };
    const money = (cents) => {
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(cents / 100); }
      catch { return `$${(cents / 100).toFixed(2)}`; }
    };
    const rowPurchasable = (row) => row && row.available !== false && /^\d+$/.test(String(row.variantId || '')) && Number(row.price) > 0 && Number.isInteger(Number(row.purchaseQuantity || 1)) && Number(row.purchaseQuantity || 1) > 0;
    const quoteUrl = (quantity, size) => {
      const url = new URL(root.dataset.contactUrl || '/pages/contact-us', window.location.origin);
      url.searchParams.set('topic', 'quote');
      url.searchParams.set('material', material());
      url.searchParams.set('quantity', String(quantity));
      if (size.valid && size.sizeMax > 4) {
        url.searchParams.set('width', size.width.toFixed(2));
        url.searchParams.set('height', size.height.toFixed(2));
      }
      return url.pathname + url.search;
    };
    const nextStep = () => {
      if (!material()) return { label: labels.nextMaterial || 'Choose material', target: materialInputs[0] };
      if (!dimensions().valid) return { label: labels.nextSize || 'Set patch size', target: !widthInput.validity.valid || !widthInput.value.trim() ? widthInput : heightInput };
      if (!validQuantity()) return { label: labels.nextQuantity || 'Set quantity', target: exactQuantity || quantityInputs.find(input => !input.disabled) };
      if (!rowPurchasable(activeRow)) return { label: labels.requestPricing || 'Request pricing', quote: true };
      if (!logoReady()) return { label: labels.nextHelp || 'Check logo help', target: logoInputs.find(input => !input.disabled) };
      if (!selectedFile && !savedArtwork?.active) return { label: labels.nextArtwork || 'Add your artwork', target: fileInput };
      return { label: labels.addToCart || 'Add to cart', ready: true };
    };
    const updateNextAction = () => {
      const step = nextStep();
      if (mobileTotal) mobileTotal.textContent = total.textContent;
      if (nextAction) {
        nextAction.textContent = step.label;
        nextAction.disabled = submitting;
        nextAction.dataset.action = step.ready ? 'cart' : step.quote ? 'quote' : 'continue';
      }
      if (readiness) {
        readiness.textContent = step.ready ? labels.ready || 'Ready to add to cart.' : (labels.incompletePattern || 'Next: [step].').replaceAll('[step]', step.label);
        readiness.dataset.ready = String(Boolean(step.ready));
      }
    };
    const update = () => {
      savedArtwork?.sync();
      const chosenMaterial = material();
      const size = dimensions();
      const needsQuote = size.valid && size.sizeMax > 4;
      root.querySelector('[data-lc-size-quote]').hidden = !needsQuote;
      showError(sizeError, size.valid ? '' : 'Enter a width and height from 0.50 to 5.00 inches, using up to two decimal places.');
      const materialRows = rows.filter(row => row.material === chosenMaterial);
      if (!exactQuantity && !materialRows.some(row => Number(row.quantity) === patchCount())) {
        const firstQuantity = Math.min(...materialRows.map(row => Number(row.quantity)));
        quantityInputs.forEach(input => { input.checked = Number(input.value) === firstQuantity; });
      }
      const count = patchCount();
      const quantityValid = validQuantity();
      if (exactQuantity) {
        exactQuantity.min = String(minimumQuantity());
        exactQuantity.setAttribute('aria-invalid', String(!quantityValid));
        quantityHint.textContent = (labels.quantityHint || 'Whole patches only. [min]–5,000 patches.').replaceAll('[min]', String(minimumQuantity()));
        showError(quantityError, quantityValid ? '' : `Enter a whole number from ${minimumQuantity()} to 5,000 patches.`);
        quantityInputs.forEach(input => { input.checked = quantityValid && Number(input.value) === count; });
      }
      root.querySelector('[data-lc-quote-link]').href = quoteUrl(count, size);
      const label = chosenMaterial === 'leatherette' ? 'leatherette' : 'PVC';
      const displayLabel = chosenMaterial === 'leatherette' ? labels.leatheretteLabel || 'leatherette' : labels.pvcLabel || 'PVC';
      const tier = unitRows.filter(row => row.material === chosenMaterial && Number(row.sizeMax) === size.sizeMax && Number(row.quantity) <= count).sort((a,b) => Number(b.quantity) - Number(a.quantity))[0];
      activeRow = quantityValid ? (tier ? { ...tier, price: Number(tier.unitPrice) * count, purchaseQuantity: count } : rows.find(row => row.material === chosenMaterial && Number(row.quantity) === count && Number(row.sizeMax) === size.sizeMax) || null) : null;
      if (tierNote) {
        tierNote.hidden = !quantityValid || !rowPurchasable(activeRow) || !tier;
        tierNote.textContent = tier ? (labels.tierNote || 'Your price uses the [tier]+ patch price break.').replaceAll('[tier]', Number(tier.quantity).toLocaleString()) : '';
      }
      root.querySelector('[data-lc-material-property]').value = label;
      root.querySelector('[data-lc-count-property]').value = count || '';
      const sizeText = size.valid ? `${size.width.toFixed(2)}″ × ${size.height.toFixed(2)}″` : '';
      root.querySelector('[data-lc-dimensions-property]').value = size.valid ? `${size.width.toFixed(2)} × ${size.height.toFixed(2)} inches` : '';
      root.querySelector('[data-lc-summary-dimensions]').textContent = sizeText;
      root.querySelector('[data-lc-summary-material]').textContent = displayLabel;
      root.querySelector('[data-lc-summary-quantity]').textContent = quantityValid ? count.toLocaleString() : '—';
      root.querySelector('[data-lc-summary-production]').textContent = chosenMaterial === 'leatherette' ? labels.leatheretteTime || '2–3 business days' : labels.pvcTime || '4–6 weeks';
      const colorProperty = root.querySelector('[data-lc-color-property]');
      colorProperty.value = chosenMaterial === 'leatherette' ? 'Buckskin' : '';
      colorProperty.disabled = chosenMaterial !== 'leatherette';
      root.querySelector('[data-lc-leatherette-note]').hidden = chosenMaterial !== 'leatherette';
      root.querySelector('[data-lc-variant]').value = rowPurchasable(activeRow) ? activeRow.variantId : '';
      root.querySelector('[data-lc-cart-quantity]').value = activeRow?.purchaseQuantity || 1;
      summaryTitle.textContent = (labels.titlePattern || '[quantity] custom [material] patches').replaceAll('[quantity]', count.toLocaleString()).replaceAll('[material]', displayLabel);
      const purchasable = rowPurchasable(activeRow);
      const helpBreakdown = root.querySelector('[data-lc-logo-breakdown]');
      if (helpBreakdown) helpBreakdown.hidden = !purchasable || !logoPaid();
      if (purchasable) {
        const orderTotal = Number(activeRow.price);
        total.textContent = money(orderTotal + (logoPaid() && logoReady() ? Number(logoVariant().price) : 0));
        root.querySelector('[data-lc-summary-subtotal]').textContent = money(orderTotal);
        const breakdown = root.querySelector('[data-lc-logo-breakdown]');
        if (breakdown) {
          breakdown.hidden = !logoPaid();
          root.querySelector('[data-lc-service-total]').textContent = money(Number(logoVariant()?.price || 0));
        }
        unitPrice.textContent = `${money(orderTotal / count)} ${labels.unitSuffix || '/ patch'}`;
        summaryNote.textContent = savedArtwork?.active ? labels.savedSummary : logoPaid() ? logoCopy.summary : activeRow.note || labels.note || 'Upload your vector artwork to complete your order.';
        configurationNote.hidden = true;
      } else {
        root.querySelector('[data-lc-summary-subtotal]').textContent = '—';
        total.textContent = !quantityValid ? 'Enter quantity' : needsQuote ? 'Request pricing' : size.valid ? labels.unavailableHeading || 'Let’s talk' : 'Enter patch size';
        unitPrice.textContent = '';
        summaryNote.textContent = !quantityValid ? 'Enter your patch quantity to see your price.' : needsQuote ? 'Contact us for pricing on your larger patch size.' : labels.unavailableNote || 'This quantity isn’t currently available to purchase online. Contact us to arrange your order.';
        configurationNote.textContent = needsQuote ? 'Your quantity is available by quote for this size.' : activeRow?.note || labels.configurationNote || 'Need this quantity? Contact us for help with your order.';
        configurationNote.hidden = !size.valid || !quantityValid;
      }
      quantityInputs.forEach(input => {
        const matching = unitRows.find(row => row.material === chosenMaterial && Number(row.quantity) === Number(input.value) && Number(row.sizeMax) === size.sizeMax) || rows.find(row => row.material === chosenMaterial && Number(row.quantity) === Number(input.value) && Number(row.sizeMax) === size.sizeMax);
        const available = rowPurchasable(matching?.unitPrice ? { ...matching, price: matching.unitPrice } : matching);
        const quantityLabel = input.closest('[data-lc-quantity-label]');
        const knownQuantity = [...rows, ...unitRows].some(row => row.material === chosenMaterial && Number(row.quantity) === Number(input.value));
        quantityLabel.hidden = !knownQuantity;
        input.disabled = !knownQuantity;
        quantityLabel.dataset.unavailable = String(!available);
        const status = quantityLabel.querySelector('[data-lc-quantity-status]');
        if (status) status.textContent = !size.valid ? labels.nextSize || 'Set patch size' : available ? `${money(Number(matching.unitPrice || Number(matching.price) / Number(input.value)))} ${labels.unitSuffix || '/ patch'}` : labels.requestPricing || 'Request pricing';
        quantityLabel.title = available ? `${Number(input.value).toLocaleString()} patches` : `${Number(input.value).toLocaleString()} patches: contact us to order`;
      });
      if (chartBody) {
        chartBody.replaceChildren();
        root.querySelector('[data-lc-chart-caption]').textContent = `${displayLabel} prices per patch`;
        root.querySelectorAll('[data-lc-size-column]').forEach(th => { th.dataset.active = String(Number(th.dataset.lcSizeColumn) === size.sizeMax); });
        [...new Set(materialRows.map(row => Number(row.quantity)))].sort((a,b) => a-b).forEach(quantity => {
          const tr = document.createElement('tr');
          tr.dataset.selected = String(quantity === count);
          const heading = document.createElement('th'); heading.scope = 'row'; heading.textContent = quantity.toLocaleString(); tr.append(heading);
          sizeMaxima.forEach(sizeMax => {
            const unit = unitRows.find(row => row.material === chosenMaterial && Number(row.quantity) === quantity && Number(row.sizeMax) === sizeMax);
            const row = materialRows.find(row => Number(row.quantity) === quantity && Number(row.sizeMax) === sizeMax);
            const td = document.createElement('td');
            if (unit || row) td.textContent = money(unit ? Number(unit.unitPrice) : Number(row.price) / quantity);
            else {
              const quoteLink = document.createElement('a');
              quoteLink.textContent = sizeMax > 4 ? 'Quote' : 'Contact us';
              quoteLink.href = quoteUrl(quantity, size);
              quoteLink.setAttribute('aria-label', `Request a quote for ${quantity.toLocaleString()} ${displayLabel} patches`);
              td.append(quoteLink);
            }
            td.dataset.active = String(sizeMax === size.sizeMax); tr.append(td);
          }); chartBody.append(tr);
        });
      }
      fileInput.accept = logoPaid() ? '.jpg,.jpeg,.png,.pdf,.ai,.svg' : '.pdf,.ai,.svg';
      fileInput.name = logoPaid() ? 'properties[Original artwork]' : 'properties[Vector artwork]';
      if (artworkDescription) artworkDescription.textContent = logoPaid() ? logoCopy.upload : vectorDescription;
      if (uploadNote) uploadNote.textContent = logoPaid() ? logoCopy.note : vectorNote;
      root.querySelector('[data-lc-file-formats]').textContent = logoPaid() ? logoCopy.formats : '.pdf, .ai, .svg only';
      root.querySelector('[data-lc-upload-label]').textContent = selectedFile ? (logoPaid() ? logoCopy.change : labels.changeLabel || 'Change vector artwork') : (logoPaid() ? logoCopy.upload : labels.uploadLabel || 'Upload vector artwork');
      submitButtons.forEach(button => { button.disabled = !size.valid || !purchasable || (!selectedFile && !savedArtwork?.active) || !logoReady() || submitting; });
      updateNextAction();
      if (!submitting) showError(orderError, '');
      saveSelection();
    };
    const clearFile = () => {
      selectedFile = null;
      fileInput.value = '';
      fileSelected.hidden = true;
      root.querySelector('[data-lc-upload-label]').textContent = labels.uploadLabel || 'Upload vector artwork';
      update();
    };
    fileInput.addEventListener('change', () => {
      const file = fileInput.files?.[0];
      if (!file) return;
      savedArtwork?.clear(false);
      if (!validFileType(file)) {
        clearFile();
        showError(artworkError, logoPaid() ? logoCopy.file_error : logoCopy.vector_error);
        fileInput.focus();
        return;
      }
      if (!file.size) {
        clearFile();
        showError(artworkError, 'This file is empty. Please choose your vector artwork again.');
        return;
      }
      if (file.size > 20 * 1024 * 1024) {
        clearFile();
        showError(artworkError, logoCopy.size_error);
        return;
      }
      selectedFile = file;
      notifyJourney('custom_artwork_selected');
      showError(artworkError, '');
      root.querySelector('[data-lc-filename]').textContent = file.name;
      root.querySelector('[data-lc-upload-label]').textContent = labels.changeLabel || 'Change vector artwork';
      fileSelected.hidden = false;
      update();
    });
    logoInputs.forEach(input => input.addEventListener('change', () => {
      if (selectedFile && !validFileType(selectedFile)) {
        clearFile();
        showError(artworkError, logoCopy.vector_error);
      } else showError(artworkError, '');
      update();
    }));
    [widthInput, heightInput].forEach(input => input.addEventListener('input', update));
    if (exactQuantity) exactQuantity.addEventListener('input', update);
    quantityInputs.forEach(input => input.addEventListener('change', () => {
      if (exactQuantity) exactQuantity.value = input.value;
      update();
    }));
    materialInputs.forEach(input => input.addEventListener('change', () => {
      if (exactQuantity && (!Number.isInteger(patchCount()) || patchCount() < minimumQuantity())) exactQuantity.value = String(minimumQuantity());
      update();
    }));
    nextAction?.addEventListener('click', () => {
      const step = nextStep();
      if (submitting) return;
      if (step.ready) {
        form.requestSubmit(submitButtons.find(button => button.value === 'cart'));
        return;
      }
      if (step.quote) {
        window.location.assign(quoteUrl(patchCount(), dimensions()));
        return;
      }
      const section = step.target?.closest('.lc-custom__upload, .lc-custom__row');
      section?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
      step.target?.focus({ preventScroll: true });
    });
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (submitting) { event.preventDefault(); return; }
      if (!dimensions().valid) {
        event.preventDefault(); update();
        (!widthInput.validity.valid ? widthInput : heightInput).focus(); return;
      }
      if (!validQuantity()) {
        event.preventDefault(); update(); exactQuantity?.focus(); return;
      }
      if (!rowPurchasable(activeRow)) {
        event.preventDefault();
        showError(orderError, 'This combination is not available online. Contact us for help with this order.');
        return;
      }
      if ((!selectedFile || !fileInput.files?.length) && !savedArtwork?.active) {
        event.preventDefault();
        showError(artworkError, logoPaid() ? logoCopy.upload_required : 'Upload your vector artwork before adding your patches to cart.');
        fileInput.focus();
        return;
      }
      if (!material() || !patchCount()) {
        event.preventDefault();
        showError(orderError, 'Choose your patch material and quantity.');
        return;
      }
      if (!logoReady()) { showError(orderError, logoCopy.unavailable); return; }
      root.querySelector('[data-lc-return-to]').value = event.submitter?.value === 'checkout' ? '/checkout' : root.dataset.cartUrl || '/cart';
      submitting = true;
      submitButtons.forEach(button => { button.disabled = true; });
      updateNextAction();
      const status = root.querySelector('[data-lc-submission-status]');
      status.textContent = savedArtwork?.active ? labels.savedAdding : labels.uploadingLabel || 'Uploading your artwork and adding your patches…';
      status.hidden = false;
      root.dispatchEvent(new CustomEvent('lc:cart-updated', { bubbles: true, detail: { pending: true, patchCount: patchCount() } }));
      const reference = `LP-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 7)}`;
      const payload = new FormData();
      payload.append('items[0][id]', String(activeRow.variantId));
      payload.append('items[0][quantity]', String(activeRow.purchaseQuantity || 1));
      const originalForm = new FormData(form);
      for (const [key, value] of originalForm.entries()) {
        const property = key.match(/^properties\[(.+)\]$/);
        if (property) payload.append(`items[0][properties][${property[1]}]`, value);
      }
      payload.append('items[0][properties][Logo help]', logoLabel());
      payload.append('items[0][properties][Design reference]', reference);
      if (logoPaid()) {
        payload.append('items[1][id]', String(logoVariant().id));
        payload.append('items[1][quantity]', '1');
        payload.append('items[1][properties][Design reference]', reference);
        payload.append('items[1][properties][For patches]', summaryTitle.textContent);
        payload.append('items[1][properties][Original artwork]', selectedFile);
      }
      try {
        const cartRoot = (window.Shopify?.routes?.root || '/');
        const response = await fetch(`${cartRoot}cart/add.js`, { method: 'POST', body: payload });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || logoCopy.cart_error);
        notifyJourney('custom_cart_added');
        window.location.assign(root.querySelector('[data-lc-return-to]').value);
      } catch (error) {
        submitting = false;
        status.hidden = true;
        update();
        showError(orderError, error.message || logoCopy.cart_error);
      }
    });
    root.querySelectorAll('[data-lc-help-open]').forEach(button => button.addEventListener('click', () => {
      helpTrigger = button;
      saveSelection();
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else window.location.href = root.dataset.helpUrl;
    }));
    root.querySelectorAll('[data-lc-help-close]').forEach(button => button.addEventListener('click', () => {
      dialog.close();
      helpTrigger?.focus();
    }));
    dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => helpTrigger?.focus());
    root.querySelector('[data-lc-help-link]')?.addEventListener('click', saveSelection);
    window.addEventListener('pageshow', () => {
      submitting = false;
      root.querySelector('[data-lc-submission-status]').hidden = true;
      update();
    });
    savedArtwork?.onChange(update);
    savedArtwork?.apply();
    update();
    if (['basic', 'complex'].includes(requestedHelp) && !savedArtwork?.active) {
      root.querySelector('[data-lc-artwork-section]')?.scrollIntoView({ behavior: 'instant', block: 'start' });
    }
  };
  const boot = (scope = document) => scope.querySelectorAll('[data-lc-custom-order]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
